export default {"src":"/_next/static/media/switchPhoto.e7cdd998.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};